export const blockIconsAudioandvideoHearingNew = (
	<span className='material-symbols-outlined'>hearing</span>
);
